import * as Sentry from "@sentry/vue";

const state = {
  loading: 0,
  currentStep: 1,
  snackbarTimeout: 6000,
  purchaseStarted: false,
  snackbar: false,
  snackbarMessage: '',
  snackbarColor: '#D33724',
  snackbarButton: false,
  errorDialog: false,
  errorMessage: '',
  expirationDialog: false,
  showDefault: false,
  showSkeleton: true,
  showResetPurchase: false,
  showResetSector: false,
  ameIsSelected: false,
  pixIsSelected: false,
  secondPaymentStep: false,
  pingAme: null,
  pingPix: null
};

const mutations = {
  ADD_LOADING(state) {
    state.loading += 1;
  },
  SUBTRACT_LOADING(state) {
    state.loading -= 1;
  },
  SET_CURRENT_STEP(state, currentStep) {
    state.currentStep = currentStep;
  },
  SET_RESET_PURCHASE(state, showResetPurchase) {
    state.showResetPurchase = showResetPurchase;
  },
  SET_RESET_SECTOR_DIALOG(state, showResetSector) {
    state.showResetSector = showResetSector;
  },
  SET_AME_SELECTED(state, ameIsSelected) {
    state.ameIsSelected = ameIsSelected;
  },
  SET_PIX_SELECTED(state, pixIsSelected) {
    state.pixIsSelected = pixIsSelected;
  },
  SET_SECOND_PAYMENT_STEP(state, secondPaymentStep) {
    state.secondPaymentStep = secondPaymentStep;
  },
  SET_SHOW_DEFAULT(state, showDefault) {
    state.showDefault = showDefault;
  },
  SET_SKELETON(state, showSkeleton) {
    state.showSkeleton = showSkeleton;
  },
  SET_PURCHASE_STARTED(state, purchaseStarted) {
    state.purchaseStarted = purchaseStarted;
  },
  SET_PING_AME(state, pingAme) {
    state.pingAme = pingAme;
  },
  SET_PING_PIX(state, pingPix) {
    state.pingPix = pingPix;
  },
  OPEN_SNACKBAR(state, props) {
    state.snackbarTimeout = props.timeout || 6000
    state.snackbar = true;
    state.snackbarMessage = props.message;
    state.snackbarColor = props.color || '#D33724';
    state.snackbarButton = props.extraButton || false
  },
  CLOSE_SNACKBAR(state) {
    state.snackbar = false;
    state.snackbarMessage = '';
    state.snackbarColor = '#D33724';
  },
  OPEN_ERROR_DIALOG(state, message) {
    state.errorDialog = true;
    state.errorMessage = message;
  },
  CLOSE_ERROR_DIALOG(state) {
    state.errorDialog = false;
    state.errorMessage = '';
  },
  SET_EXPIRATION_DIALOG(state, payload) {
    state.expirationDialog = payload;
  },
};

const actions = {
  addLoading: ({ commit }) => {
    commit('ADD_LOADING');

    // remover os loadings que passaram os X segundos
    const currentLoading = state.loading;
    setTimeout(() => {
      if (state.loading >= currentLoading) {
        const diff = state.loading - currentLoading;
        const times = diff > 0 ? diff : 1;
        for (let i = 0; i < times; i++) {
          commit('SUBTRACT_LOADING');
        }
      }
    }, process.env.VUE_APP_TIMEOUT * 10);
  },
  subtractLoading: ({ commit }) => {
    commit('SUBTRACT_LOADING');
  },
  setCurrentStep: ({ commit }, currentStep) => {
    commit('SET_CURRENT_STEP', currentStep);
  },
  setPingAme: ({ commit }, pingAme) => {
    commit('SET_PING_AME', pingAme);
  },
  setPingPix: ({ commit }, pingPix) => {
    commit('SET_PING_PIX', pingPix);
  },
  setResetPurchase: ({ commit }, showResetPurchase) => {
    commit('SET_RESET_PURCHASE', showResetPurchase);
  },
  setResetSector: ({ commit }, showResetSector) => {
    commit('SET_RESET_SECTOR_DIALOG', showResetSector);
  },
  setPurchaseStarted: ({ commit }, purchaseStarted) => {
    commit('SET_PURCHASE_STARTED', purchaseStarted);
  },
  nextStep: ({ dispatch, getters }) => {
    if (getters.currentStep < 5) {
      dispatch('setCurrentStep', getters.currentStep + 1);
    }
  },
  backAStep: ({ commit, getters , dispatch }) => {
    if(getters.currentStep === 3 || getters.currentStep === 2) {
      dispatch('setResetPurchase', true)
    } else dispatch('setCurrentStep', getters.currentStep - 1);
  },

  openSnackbar: ({ commit }, props) => {
    commit('OPEN_SNACKBAR', props);
  },
  closeSnackbar: ({ commit }) => {
    commit('CLOSE_SNACKBAR');
  },
  openErrorDialog: ({ commit }, message) => {
    commit('OPEN_ERROR_DIALOG', message);
    setTimeout(() => {
      commit('CLOSE_ERROR_DIALOG');
    }, 3500)
  },
  closeErrorDialog: ({ commit }) => {
    commit('CLOSE_ERROR_DIALOG');
  },
  backToSelection: ({ commit }) => {
    commit('SET_SHOW_DEFAULT', true);
    commit('SET_SELECTED_SEAT', null);
    // commit('SET_SELECTED_SECTOR', null);
    // commit('SET_SECTOR_MAP', null);
  },
  resetSelection: ({ commit }) => {
    // commit('SET_SHOW_DEFAULT', false);
    commit('SET_SELECTED_SEAT', null);
    commit('SET_SELECTED_SECTOR', null);
    commit('SET_SECTOR_MAP', null);
  },
  setExpirationDialog: ({ commit }, payload) => {
    commit('SET_EXPIRATION_DIALOG', payload);
  },
  setSkeleton: ({ commit }, showSkeleton) => {
    commit('SET_SKELETON', showSkeleton);
  },
  sendPostMessage: (_, payload) => {
    window.parent.postMessage(payload, '*');
  },
};

const getters = {
  loading(state) {
    return state.loading > 0;
  },
  snackbarButton(state) {
    return state.snackbarButton;
  },
  showDefault(state) {
    return state.showDefault;
  },
  showSkeleton(state) {
    return state.showSkeleton;
  },
  currentStep(state) {
    return state.currentStep;
  },
  purchaseStarted(state) {
    return state.purchaseStarted;
  },
  snackbar(state) {
    return state.snackbar;
  },
  snackbarMessage(state) {
    return state.snackbarMessage;
  },
  ameIsSelected(state) {
    return state.ameIsSelected;
  },
  pixIsSelected(state) {
    return state.pixIsSelected;
  },
  secondPaymentStep(state) {
    return state.secondPaymentStep;
  },
  snackbarColor(state) {
    return state.snackbarColor;
  },
  snackbarTimeout(state) {
    return state.snackbarTimeout;
  },
  errorDialog(state) {
    return state.errorDialog;
  },
  errorMessage(state) {
    return state.errorMessage;
  },
  expirationDialog(state) {
    return state.expirationDialog;
  },
  showResetPurchase(state) {
    return state.showResetPurchase;
  },
  showResetSector(state) {
    return state.showResetSector;
  },
  pingAme(state) {
    return state.pingAme;
  },
  pingPix(state) {
    return state.pingPix;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
